import Styled from 'styled-components'

export default Styled.div`
  position: relative;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: calc(100% + 4.5rem);
  }
    ${props => props.isOpen && `
      transform: scale(1.025);
      z-index: 1;
      background: #fff;
      box-shadow: 0 0.25rem 1rem 0 rgba(51, 51, 51, 0.1);
  
      &:before {
        display: none;
      }
    `}

  ${props => (!props.isDisabled && !props.isOpen) && `
    &:hover {
      z-index: 1;

      [data-selector="page-component-controls"] {
        display: block;
      }
    }
  `}

  ${props => props.isDisabled && `
    opacity: 0.3;
  `}
`



// WEBPACK FOOTER //
// ./src/components/PageComponent/index.js